import script from "./ChannelItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelItem.vue?vue&type=script&setup=true&lang=js"

import "./ChannelItem.vue?vue&type=style&index=0&id=7d5c5308&lang=scss"

const __exports__ = script;

export default __exports__